<template>
  <!-- Dashboard Content
	================================================== -->
  <div class="dashboard-content-container" data-simplebar>
    <div class="dashboard-content-inner">
      <!-- Dashboard Headline -->
      <div class="dashboard-headline">
        <h3>Reviews</h3>

        <!-- Breadcrumbs -->
        <nav id="breadcrumbs" class="dark">
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">Dashboard</a></li>
            <li>Reviews</li>
          </ul>
        </nav>
      </div>

      <!-- Row -->
      <div class="row">
        <!-- Dashboard Box -->
        <!-- Rate Employers
        ================================================== -->
        <div class="col-xl-6">
          <div class="dashboard-box margin-top-0">
            <!-- Headline -->
            <div class="headline">
              <h3><i class="icon-material-outline-business"></i> Rate Employers</h3>
            </div>

            <div class="content">
              <ul
                class="dashboard-box-list"
                v-if="completedApplications && completedApplications.length"
              >
                <template v-if="applicationsWithoutReviews.length">
                  <!-- incomplete review -->
                  <li v-for="review in applicationsWithoutReviews" :key="review.id">
                    <div class="boxed-list-item">
                      <!-- Content -->
                      <div class="item-content">
                        <h4>{{ review.projects.title }}</h4>
                        <span class="company-not-rated margin-bottom-5">Not Rated</span>
                      </div>
                    </div>

                    <button
                      @click="
                        openReviewPopup({
                          id: review.id,
                          selectedProjectOwnerName: review.projects.owner.name,
                          selectedProjectTitle: review.projects.title,
                        })
                      "
                      class="popup-with-zoom-anim button ripple-effect margin-top-5 margin-bottom-10"
                      ><i class="icon-material-outline-thumb-up"></i> Leave a Review</button
                    >
                  </li>
                  <!-- incomplete review / End -->
                </template>

                <template v-if="applicationsWithReviews.length">
                  <!-- completed review -->
                  <li v-for="review in applicationsWithReviews" :key="review.id">
                    <div class="boxed-list-item">
                      <!-- Content -->
                      <div class="item-content">
                        <h4>{{ review.projects.title }}</h4>
                        <div class="item-details margin-top-10">
                          <div class="star-rating" :data-rating="`${review.owner_rating}.0`"></div>
                          <div class="detail-item"
                            ><i class="icon-material-outline-date-range"></i>
                            {{ review.isCompleted_owner }}</div
                          >
                        </div>
                        <div class="item-description">
                          <p>{{ review.taskMaster_comment }}.</p>
                        </div>
                      </div>
                    </div>
                  </li>
                  <!-- completed review / End -->
                </template>
              </ul>
            </div>
          </div>

          <!-- Rate Employer || Applications Pagination -->
          <div class="clearfix"></div>
          <div
            class="pagination-container margin-top-40 margin-bottom-0 d-flex justify-content-center"
          >
            <nav class="pagination">
              <ul>
                <li
                  class="pagination-arrow"
                  :class="[prevApplicationsPageUrl === null ? 'isDisabled' : '']"
                  ><a href="#" class="ripple-effect" @click="getPrevPage('applications')"
                    ><i class="icon-material-outline-keyboard-arrow-left"></i></a
                ></li>
                <!-- <template v-if="applicationsPaginationTotal < 5">
                  <li v-for="index in applicationsPaginationTotal" :key="index">
                    <a
                      href="#"
                      @click="getMyCompletedApplications(index)"
                      class="ripple-effect"
                      :class="[currentApplicationsPage === index ? 'current-page' : '']"
                      >{{ index }}</a
                    >
                  </li>
                </template> -->

                <li
                  class="pagination-arrow "
                  :class="[nextApplicationsPageUrl === null ? 'isDisabled' : '']"
                  ><a href="#" class="ripple-effect" @click="getNextPage('applications')"
                    ><i class="icon-material-outline-keyboard-arrow-right"></i></a
                ></li>
              </ul>
            </nav>
          </div>
          <div class="clearfix"></div>
          <!-- Pagination / End -->
        </div>
        <!-- Rate Employers / End -->

        <!-- Dashboard Box -->
        <!-- Rate Freelancers
        ================================================== -->
        <div class="col-xl-6">
          <div class="dashboard-box margin-top-0">
            <!-- Headline -->
            <div class="headline">
              <h3><i class="icon-material-outline-face"></i> Rate Freelancers</h3>
            </div>

            <div class="content">
              <ul class="dashboard-box-list" v-if="completedProjects && completedProjects.length">
                <!-- Projects Without Reviews -->
                <template v-if="projectsWithoutReviews.length">
                  <li v-for="project in projectsWithoutReviews" :key="project.id">
                    <div class="boxed-list-item">
                      <div class="item-content">
                        <h4>{{ project.title }}</h4>
                        <span class="company-not-rated margin-bottom-5">Not Rated</span>
                      </div>
                    </div>

                    <button
                      class="popup-with-zoom-anim button ripple-effect margin-top-5 margin-bottom-10"
                      @click="
                        openReviewPopup({
                          id: project.id,
                          selectedProjectOwnerName: project.owner.name,
                          selectedProjectTitle: project.task.name,
                        })
                      "
                      ><i class="icon-material-outline-thumb-up"></i> Leave a Review</button
                    >
                  </li>
                </template>

                <!-- Projects With Reviews -->
                <template v-if="projectsWithReviews.length">
                  <li v-for="project in projectsWithReviews" :key="project.id">
                    <div class="boxed-list-item">
                      <!-- Content -->
                      <div class="item-content">
                        <h4>{{ project.title }}</h4>
                        <div class="item-details margin-top-10">
                          <div
                            class="star-rating"
                            :data-rating="`${project.owner.ratings}.0`"
                          ></div>
                          <div class="detail-item"
                            ><i class="icon-material-outline-date-range"></i>
                            {{ project.completed_on }}</div
                          >
                        </div>
                        <div class="item-description">
                          <p>{{ project.applications[0].owner_comment }}</p>
                        </div>
                      </div>
                    </div>
                  </li>
                </template>
              </ul>
            </div>
          </div>

          <!-- Rate Freelancer || Projects Pagination -->
          <div class="clearfix"></div>
          <div
            class="pagination-container margin-top-40 margin-bottom-0 d-flex justify-content-center"
          >
            <nav class="pagination">
              <ul>
                <li
                  class="pagination-arrow"
                  :class="[prevProjectsPageUrl === null ? 'isDisabled' : '']"
                  ><a href="#" class="ripple-effect" @click="getPrevPage('projects')"
                    ><i class="icon-material-outline-keyboard-arrow-left"></i></a
                ></li>
                <!-- <template v-if="projectsPaginationTotal < 5">
                  <li v-for="index in projectsPaginationTotal" :key="index">
                    <a
                      href="#"
                      @click="getMyCompletedApplications(index)"
                      class="ripple-effect"
                      :class="[currentApplicationsPage === index ? 'current-page' : '']"
                      >{{ index }}</a
                    >
                  </li>
                </template> -->

                <li
                  class="pagination-arrow "
                  :class="[nextProjectsPageUrl === null ? 'isDisabled' : '']"
                  ><a href="#" class="ripple-effect" @click="getNextPage('projects')"
                    ><i class="icon-material-outline-keyboard-arrow-right"></i></a
                ></li>
              </ul>
            </nav>
          </div>
          <div class="clearfix"></div>
          <!-- Pagination / End -->
        </div>

        <!-- Rate Freelancers / End -->
      </div>
      <!-- Row / End -->

      <!-- Footer -->
      <div class="dashboard-footer-spacer"></div>
      <div class="small-footer margin-top-15">
        <div class="small-footer-copyrights">
          © 2019 <strong>Hireo</strong>. All Rights Reserved.
        </div>
        <ul class="footer-social-links">
          <li>
            <a href="#" title="Facebook" data-tippy-placement="top">
              <i class="icon-brand-facebook-f"></i>
            </a>
          </li>
          <li>
            <a href="#" title="Twitter" data-tippy-placement="top">
              <i class="icon-brand-twitter"></i>
            </a>
          </li>
          <li>
            <a href="#" title="Google Plus" data-tippy-placement="top">
              <i class="icon-brand-google-plus-g"></i>
            </a>
          </li>
          <li>
            <a href="#" title="LinkedIn" data-tippy-placement="top">
              <i class="icon-brand-linkedin-in"></i>
            </a>
          </li>
        </ul>
        <div class="clearfix"></div>
      </div>
      <!-- Footer / End -->
    </div>

    <!-- Leave a Review for Freelancer Popup
================================================== -->
    <div v-show="isReviewPopupOpen" class="mfp-bg my-mfp-zoom-in mfp-ready"></div>
    <div
      v-show="isReviewPopupOpen"
      class="mfp-wrap mfp-close-btn-in mfp-auto-cursor my-mfp-zoom-in mfp-ready"
      tabindex="-1"
      style="top: 0px; position: absolute; height: 409px;"
      ><div class="mfp-container mfp-inline-holder"
        ><div class="mfp-content"
          ><div id="small-dialog-2" class="zoom-anim-dialog dialog-with-tabs">
            <!--Tabs -->
            <div class="sign-in-form">
              <ul class="popup-tabs-nav" style="pointer-events: none;"> </ul>

              <div class="popup-tabs-container">
                <!-- Tab -->
                <div class="popup-tab-content" id="tab2" style="">
                  <!-- Welcome Text -->
                  <div class="welcome-text">
                    <h3>Leave a Review</h3>
                    <span
                      >Rate <a href="#">{{ selectedProjectOwnerName }}</a> for the project
                      <a href="#">{{ selectedProjectTitle }}</a>
                    </span>
                  </div>

                  <!-- Form -->
                  <form method="post">
                    <div class="feedback-yes-no">
                      <strong>Your Rating</strong>
                      <div class="leave-rating">
                        <template v-for="(number, index) in maxStarRating">
                          <input
                            :key="`input-${number}`"
                            type="radio"
                            name="rating"
                            :id="`rating-radio-${number}`"
                            :value="number"
                            required=""
                            @click="review.rating = maxStarRating - index"
                          />
                          <label
                            :key="`label-${number}`"
                            :for="`rating-radio-${number}`"
                            class="icon-material-outline-star"
                          ></label>
                        </template>
                      </div>
                      <div class="clearfix"></div>
                    </div>

                    <textarea
                      class="with-border"
                      placeholder="Comment"
                      name="message2"
                      cols="7"
                      required=""
                      spellcheck="false"
                      v-model="review.comment"
                    ></textarea>
                  </form>

                  <!-- Button -->
                  <button
                    @click="rateAndComment()"
                    class="button full-width button-sliding-icon ripple-effect"
                    type="submit"
                    style="width: 30px;"
                    >Leave a Review <i class="icon-material-outline-arrow-right-alt"></i
                  ></button>
                </div>
              </div>
            </div>
            <button
              @click="isReviewPopupOpen = false"
              title="Close Review Popup"
              type="button"
              class="mfp-close"
            ></button>
          </div>
        </div>
      </div>
    </div>

    <!-- Leave a Review Popup / End -->
  </div>
  <!-- Dashboard Content / End -->
</template>

<script>
  /* eslint-disable no-console */

  import { getCall, postCall } from '../../../core/services/http.service';
  import { MY_COMPLETED_PROJECTS } from '../../../core/config/endpoints/projects';
  import { RATE_A_SERVICE } from '../../../core/config/endpoints/project-ratings';
  import { MY_COMPLETED_APPLICATIONS } from '../../../core/config/endpoints/project-applications';

  export default {
    data() {
      return {
        completedApplications: [],
        currentApplicationsPage: 1,
        nextApplicationsPageUrl: '',
        prevApplicationsPageUrl: '',
        applicationsPaginationTotal: 0,
        applicationItemsPerPage: 0,
        totalCompletedApplications: 0,
        isReviewPopupOpen: false,

        completedProjects: [],
        currentProjectsPage: 1,
        nextProjectsPageUrl: '',
        prevProjectsPageUrl: '',
        projectsPaginationTotal: 0,
        projectItemsPerPage: 0,
        totalCompletedProjects: 0,

        validEndpointType: {
          applications: 'applications',
          projects: 'projects',
        },

        selectedProjectOwnerName: '',
        selectedProjectTitle: '',

        review: {
          project_id: 0,
          rating: 0,
          comment: '',
        },

        maxStarRating: 5,
      };
    },
    created() {
      this.getMyCompletedApplications();
      this.getMyCompletedProjects();
    },
    computed: {
      applicationsWithReviews() {
        return this.completedApplications.filter(
          (completedApplication) => completedApplication.owner_rating !== null
        );
      },
      applicationsWithoutReviews() {
        return this.completedApplications.filter(
          (completedApplication) => completedApplication.owner_rating === null
        );
      },

      projectsWithReviews() {
        return this.completedProjects.filter(
          (completedProject) => parseInt(completedProject.owner.ratings) !== 0
        );
      },
      projectsWithoutReviews() {
        return this.completedProjects.filter(
          (completedProject) => parseInt(completedProject.owner.ratings) === 0
        );
      },
    },
    methods: {
      getMyCompletedApplications(pageNumber = null) {
        pageNumber = pageNumber ? pageNumber : this.currentApplicationsPage;
        console.log(this.currentApplicationsPage);
        this.$store.commit('setIsLoaded', true);
        getCall(`${MY_COMPLETED_APPLICATIONS.APPLICATIONS(pageNumber)}`)
          .then((response) => {
            this.nextApplicationsPageUrl = response.data.next_page_url;
            this.prevApplicationsPageUrl = response.data.prev_page_url;
            this.totalCompletedApplications = response.data.total;
            this.applicationItemsPerPage = response.data.per_page;
            this.currentApplicationsPage = response.data.current_page;
            this.completedApplications = response.data.data;
            this.getPaginationTotal('applications');
          })
          .catch((error) => {
            this.$toast.error(`${error.response.data.message}`);
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
      },
      getMyCompletedProjects(pageNumber = 1) {
        pageNumber = pageNumber ? pageNumber : this.currentProjectsPage;
        this.$store.commit('setIsLoaded', true);
        getCall(`${MY_COMPLETED_PROJECTS.PROJECTS(pageNumber)}`)
          .then((response) => {
            this.nextProjectsPageUrl = response.data.data.next_page_url;
            this.prevProjectsPageUrl = response.data.data.prev_page_url;
            this.totalCompletedProjects = response.data.data.total;
            this.projectItemsPerPage = response.data.data.per_page;
            this.currentProjectsPage = response.data.data.current_page;
            this.completedProjects = response.data.data.data;
            this.getPaginationTotal('projects');
          })
          .catch((error) => {
            this.$toast.error(`${error.response.data.message}`);
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
      },
      rateAndComment() {
        if (!this.isReviewComplete(this.review)) return null;
        this.$store.commit('setIsLoaded', true);
        postCall(RATE_A_SERVICE, this.review)
          .then((response) => {
            console.log(response);
            this.getMyCompletedProjects(this.currentProjectsPage);
          })
          .catch((error) => {
            this.$toast.error(`${error.response.data.message}`);
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
      },
      openReviewPopup({ id, selectedProjectOwnerName, selectedProjectTitle }) {
        this.review.project_id = id; //pass to the endpoint

        this.selectedProjectOwnerName = selectedProjectOwnerName; //pass into the modal
        this.selectedProjectTitle = selectedProjectTitle; //pass into the modal
        this.isReviewPopupOpen = true;
      },
      setStarRating(id) {
        this.review.rating = id;
        console.log('Rating: ' + this.review.rating);
      },
      getPrevPage(endpointType) {
        if (this.validEndpointType[endpointType] === undefined)
          return this.$toast.warning('Invalid endpoint');

        if (this.validEndpointType[endpointType] === this.validEndpointType.applications) {
          this.currentApplicationsPage--;
          console.log(this.currentApplicationsPage);
          this.getMyCompletedApplications();
        } else if (this.validEndpointType[endpointType] === this.validEndpointType.projects) {
          this.currentProjectsPage--;
          this.getMyCompletedProjects();
        }
      },
      getNextPage(endpointType) {
        if (this.validEndpointType[endpointType] === undefined)
          return this.$toast.warning('Invalid endpoint');

        if (this.validEndpointType[endpointType] === this.validEndpointType.applications) {
          this.currentApplicationsPage++;
          this.getMyCompletedApplications(this.currentApplicationsPage);
        } else if (this.validEndpointType[endpointType] === this.validEndpointType.projects) {
          this.currentProjectsPage++;
          this.getMyCompletedProjects(this.currentProjectsPage);
        }
      },
      getPaginationTotal(endpointType) {
        if (this.validEndpointType[endpointType] === undefined)
          return console.log('This is not an valid endpoint type');

        if (this.validEndpointType[endpointType] === this.validEndpointType.applications) {
          this.applicationsPaginationTotal = Math.ceil(
            this.totalCompletedApplications / this.applicationItemsPerPage
          );
        } else if (this.validEndpointType[endpointType] === this.validEndpointType.projects) {
          this.projectsPaginationTotal = Math.ceil(
            this.totalCompletedProjects / this.projectItemsPerPage
          );
        }
      },

      isReviewComplete(review) {
        if (review.rating === 0) {
          this.$toast.error(`Please rate this project with a star`);
          return false;
        }
        if (review.comment === '' || review.comment.match(/(\w+)/g).length < 10) {
          this.$toast.error(`Please enter a valid comment of 10 or more words to leave a review`);

          return false;
        }

        return true;
      },
    },
  };
</script>

<style>
  .pagination ul li + li {
    margin-left: 5px !important;
  }
  .isDisabled {
    color: currentColor !important ;
    cursor: not-allowed !important ;
    opacity: 0.5 !important ;
    text-decoration: none !important ;
    pointer-events: none !important ;
  }

  .isDisabled > li {
    color: currentColor;
    display: inline-block; /* For IE11/ MS Edge bug */
    pointer-events: not-allowed;
    text-decoration: none;
  }
  .modal-bg {
    background: #1111117d !important;
    z-index: 2000;
  }
</style>
